module.exports = __webpack_public_path__ + "static/media/SangBleuVersailles-Regular-WebM.3bef01e6.woff";